import settings from './global'

export default settings
